// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4196":"1361afa1d7abd5eb","4740":"359e5e9a752dc27a"}[chunkId] + ".css";
};